import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "container-xl" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("h2", null, "Schedule Templates", -1);
import { ScheduleTemplatesTable, NewScheduleTemplateButton } from '@/components/Schedule';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createVNode(_unref(ScheduleTemplatesTable)),
                _createVNode(_unref(NewScheduleTemplateButton))
            ]));
        };
    }
});
